//Clinic Images
import estanciaPopImg from "../assets/static/clinics/estanciapopayan.jpg";
import nuestraIbagImg from "../assets/static/clinics/nuestraibague.jpg";
import nuestraCartImg from "../assets/static/clinics/nuestracartagena.jpg";
import rosalesPereImg from "../assets/static/clinics/rosalespereira.jpg";
import corazonMedImg from "../assets/static/clinics/corazonmedellin.jpg";
import antioquiaItagImg from "../assets/static/clinics/antioquiaitagui.jpg";
import antioquiaBellImg from "../assets/static/clinics/antioquiabello.jpg";
import versallesManiImg from "../assets/static/clinics/versallesmanizales.jpg";
import mercedBarrImg from "../assets/static/clinics/mercedbarranquilla.jpg";
import centralqArmeImg from "../assets/static/clinics/ccqarmenia.jpg";
import logoCuadrado from "../assets/static/go4.png";

import { storeService } from "./storeService";

export const clinicsM = {
  Maping,
  Clinic,
  MapingIsa,
  MapingAPP,
};

function Maping() {
  const clinicsMaping = {
    14: 9,
    45: 45,
    35: 43,
    46: 46,
    49: 49,
    10: 5,
    48: 42,
    26: 33,
    12: 7,
    47: 47,
    4: 10,
    50: 50,
    52: 52,
    27: 27,
    3: 30,
    16: 11,
    11: 6,
    9: 4,
    6: 1,
    7: 2,
    51: 51,
    54: 54,
  };
  return clinicsMaping;
}

function MapingAPP() {
  const clinicsMaping = {
    9: 14,
    45: 45,
    43: 35,
    46: 46,
    49: 49,
    5: 10,
    42: 48,
    33: 26,
    7: 12,
    47: 47,
    10: 4,
    50: 50,
    52: 52,
    27: 27,
    30: 3,
    11: 16,
    6: 11,
    4: 9,
    1: 6,
    2: 7,
    51: 51,
    54: 54,
  };
  return clinicsMaping;
}

function MapingIsa() {
  const clinicsMaping = {
    27: 27,
    29: 28,
    28: 33,
    //14: 19,
    14: 9,
    10: 5,
    5: 10,
    19: 14,
    11: 6,
    9: 4,
    6: 1,
    7: 2,
    15: 10,
    2: 15,
    16: 11,
    2: 7,
    13: 33,
    3: 30,
    30: 3,
    31: 31,
    32: 32,
    26: 33,
    33: 26,
    44: 36,
    36: 44,
    45: 45,
    12: 7,
    16: 11,
    31: 43,
    46: 46,
    50: 50,
    51: 51,
    52: 52,
    54: 54,
  };
  return clinicsMaping;
}

/**
 * Roster de clínicas del selector.
 *
 * `nit` es el NIT con el que la API de Encuestas identifica a la clínica: tiene
 * que coincidir EXACTO con el `clientes.nit` dado de alta allá. Sin él, la
 * encuesta muestra el selector de clínica de la API; con un NIT que allá no
 * existe, esa clínica no ve la encuesta. El resto de la app funciona igual.
 *
 * Al agregar una clínica se le pone el NIT aquí y no hay nada más que tocar.
 * Si se descomenta una de las entradas de abajo, también hay que ponerle el suyo.
 *
 * Las dos sedes de Clínica Antioquia (Itagüí y Bello) comparten `cli_id: 14`, así
 * que comparten NIT: en ASM hay una sola fila para esa clínica.
 */
function Clinic() {
  const clinics = [
    { name: "HOSVITAL_NSDR_OS", city: "", image: logoCuadrado, cli_id: 27, nit: "805023423" },
    {
      name: "Clinica Ospedale Manizales",
      city: "",
      image: logoCuadrado,
      cli_id: 26,
      nit: "810003245",
    },
    /*     {
      name: "San Juan de Dios",
      city: "",
      image: logoCuadrado,
      cli_id: 51,
    }, */
    {
      name: "Los Rosales",
      city: "Pereira Risaralda",
      image: rosalesPereImg,
      cli_id: 7,
      nit: "891409981",
    },
    {
      name: "INOOS ",
      city: "",
      image: logoCuadrado,
      cli_id: 48,
      nit: "901497939",
    },
    {
      name: "Clínica la Estancia",
      city: "Popayan Cauca",
      image: estanciaPopImg,
      cli_id: 4,
      nit: "817003166",
    },
    {
      name: "Clínica Central del eje",
      city: "",
      image: logoCuadrado,
      cli_id: 35,
      nit: "901685966",
    },
    {
      name: "Clínica Central del eje pruebas",
      city: "",
      image: logoCuadrado,
      cli_id: 46,
      nit: "",
    },
    {
      name: "Sagrado Corazón",
      city: "",
      image: corazonMedImg,
      cli_id: 12,
      nit: "900408220",
    },
    { name: "Corpas", city: "", image: logoCuadrado, cli_id: 44, nit: "830113849" },

    { name: "CCQ Pruebas", city: "", image: logoCuadrado, cli_id: 19, nit: "" },
    {
      name: "Clínica Antioquia",
      city: "Itagui Antioquia",
      image: antioquiaItagImg,
      cli_id: 14,
      nit: "800190884",
    },
    {
      name: "Clínica Antioquia",
      city: "Bello Antioquia",
      image: antioquiaBellImg,
      cli_id: 14,
      nit: "800190884",
    },
    {
      name: "Antioquia Pruebas",
      city: "Antioquia",
      image: antioquiaBellImg,
      cli_id: 45,
      nit: "",
    },
    {
      name: "Clínica Central del Quindio",
      city: "Armenia Quindio",
      image: centralqArmeImg,
      cli_id: 10,
      nit: "900848340",
    },
    /*     {
      name: "Clínica Nuestra Pruebas",
      city: "Cali Valle",
      image: nuestraIbagImg,
      cli_id: 32,
    }, */
    //{name: "Clinica Local", city: "", image: "", cli_id: 22},
    {
      name: "Clínica Nuestra",
      city: "Cali Valle",
      image: nuestraIbagImg,
      cli_id: 11,
      nit: "805023423cal",
    },
    {
      name: "Clínica Nuestra",
      city: "Cartagena Bolivar",
      image: nuestraCartImg,
      cli_id: 9,
      nit: "805023423ca",
    },
    {
      name: "Clínica Nuestra",
      city: "Ibagué Tolima",
      image: nuestraIbagImg,
      cli_id: 6,
      nit: "805023423ib",
    },
    //{name: "Clínica Los Rosales", city: "Pereira Risaralda", image: rosalesPereImg, cli_id: 7},
    //{name: "Clínica Rosales Pruebas", city: "", image: "", cli_id: 21},
    //{name: "Clínica Corpas", city: "Bogotá D.C", image: "", cli_id: 8},
    //{name: "Desarrollo", city: "", image: "", cli_id: 17},
    //{name: "Clínica la Estancia", city: "Popayan Cauca", image: estanciaPopImg, cli_id: 15},
    {
      name: "Clínica la Estancia pruebas",
      city: "Popayan Cauca",
      image: estanciaPopImg,
      cli_id: 3,
      nit: "",
    },
    //{name: "G-OCHO", city: "", image: "", cli_id: 18},
    { name: "G-OCHO PRUEBAS", city: "", image: logoCuadrado, cli_id: 2, nit: "" },
    {
      name: "Clínica La Merced",
      city: "Barranquilla Atlantico",
      image: mercedBarrImg,
      cli_id: 16,
      nit: "800094898",
    },
    { name: "La Merced Pruebas", city: "", image: centralqArmeImg, cli_id: 20, nit: "" },
    {
      name: "Clínica Versalles",
      city: "Manizales Caldas",
      image: versallesManiImg,
      cli_id: 13,
      nit: "810003245",
    },
    {
      name: "Hospital Infantil Los angeles",
      city: "",
      image: logoCuadrado,
      cli_id: 50,
      nit: "891200240",
    },
    {
      name: "Hospital Infantil Los angeles PRUEBAS",
      city: "",
      image: logoCuadrado,
      cli_id: 52,
      nit: "",
    },
    /*     {
      name: "San Juan de Dios PRUEBAS",
      city: "",
      image: logoCuadrado,
      cli_id: 54,
    }, */
    {
      name: "Los Rosales pruebas",
      city: "Pereira Risaralda",
      image: rosalesPereImg,
      cli_id: 29,
      nit: "",
    },
  ];
  return clinics;
}
